import React from "react";
import { graphql } from "gatsby";
import { TreeListing } from "./TreeListing";
import { useTrees } from "../../../lib/useTrees";
import { KontentComponentSettings } from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";

interface Props extends KontentComponentSettings {
  tree_collection: {
    value: {
      codename: string;
      value: string;
    }[];
  };
}

const TreeListingContainer: React.FC<Props> = ({
  tree_collection,
  component_settings__hide_on_mobile,
  component_settings__anchor_name,
  ...props
}) => {
  const treesData = useTrees();
  const selectedCollections = tree_collection?.value;

  const trees =
    !selectedCollections || selectedCollections.length === 0
      ? treesData.trees
      : selectedCollections.flatMap(
          (collection) => treesData.collections[collection.codename]?.trees
        );

  if (!trees) return null;

  return (
    <TreeListing
      anchor={component_settings__anchor_name?.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
      trees={trees}
      {...props}
    ></TreeListing>
  );
};

export default TreeListingContainer;

export const fragmentTreeListingContainer = graphql`
  fragment TreeListing on kontent_item_component___tree_listing {
    elements {
      tree_collection {
        value {
          codename
        }
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
    }
  }
`;
